import Vue from 'vue';
import VueRouter from 'vue-router';
import index from '../views/index.vue';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    indexnum: '1',
    component: index,
    redirect: 'hghome',
    children: [
      
      {
        path: 'hghome',
        name: 'hghome',
        indexnum: '1',
        component: () => import(/* webpackChunkName: "home" */ '../views/hghome.vue'),
        meta: { title: '首页' },
      },
      {
        path: 'hghome_mine',
        name: 'hghome_mine',
        indexnum: '1',
        component: () => import(/* webpackChunkName: "home" */ '../views/hghome_mine.vue'),
        meta: { title: '首页' },
      },
      {
        path: 'hghome_searchresult',
        name: 'hghome_searchresult',
        indexnum: '1',
        component: () => import(/* webpackChunkName: "home" */ '../views/hghome_searchresult.vue'),
        meta: { title: '首页' },
      },
      {
        path: 'hghome_datadetail',
        name: 'hghome_datadetail',
        indexnum: '1',
        component: () => import(/* webpackChunkName: "home" */ '../views/hghome_datadetail.vue'),
        meta: { title: '首页' },
      },

      {
        path: 'hgbookread',
        name: 'hgbookread',
        indexnum: '2',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgbookread.vue'),
        meta: { title: '原书查阅' },
      },
      {
        path: 'hgbookread_searchresult',
        name: 'hgbookread_searchresult',
        indexnum: '2',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgbookread_searchresult.vue'),
        meta: { title: '原书查阅' },
      },
      {
        path: 'hgdatacount',
        name: 'hgdatacount',
        indexnum: '3',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgdatacount.vue'),
        meta: { title: '数据汇总' },
      },
      {
        path: 'hgsearch',
        name: 'hgsearch',
        indexnum: '4',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgsearch.vue'),
        meta: { title: '内容检索' },
      },
      {
        path: 'hgresearch',
        name: 'hgresearch',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch.vue'),
        meta: { title: '海关研学' },
      },

      {
        path: 'hgresearch_list',
        name: 'hgresearch_list',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_list.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgresearch_list_compare',
        name: 'hgresearch_list_compare',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_list_compare.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgresearch_list_cz',
        name: 'hgresearch_list_cz',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_list_cz.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgresearch_list_sc',
        name: 'hgresearch_list_sc',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_list_sc.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgresearch_list_talk',
        name: 'hgresearch_list_talk',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_list_talk.vue'),
        meta: { title: '海关研学' },
      },

      
      
      {
        path: 'hgresearch_cz',
        name: 'hgresearch_cz',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_cz.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgresearch_new',
        name: 'hgresearch_new',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_new.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgresearch_compare',
        name: 'hgresearch_compare',
        indexnum: '5',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgresearch_compare.vue'),
        meta: { title: '海关研学' },
      },
      {
        path: 'hgtalk',
        name: 'hgtalk',
        indexnum: '6',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgtalk.vue'),
        meta: { title: '研学论坛' },
      },
      {
        path: 'hgtalk_detail',
        name: 'hgtalk_detail',
        indexnum: '6',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgtalk_detail.vue'),
        meta: { title: '研学论坛' },
      },
      {
        path: 'hgsub',
        name: 'hgsub',
        indexnum: '7',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgsub.vue'),
        meta: { title: '子库调用' },
      },
      {
        path: 'hgsub_detail',
        name: 'hgsub_detail',
        indexnum: '7',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgsub_detail.vue'),
        meta: { title: '子库调用' },
      },
      {
        path: 'hgtool',
        name: 'hgtool',
        indexnum: '8',
        component: () => import(/* webpackChunkName: "home" */ '../views/hgtool.vue'),
        meta: { title: '研究工具' },
      },


    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
